
import { Component, Vue } from 'vue-property-decorator';
import { WPXFormValue } from '@/components/templates/WPXForm';
import CreateCronFilterForm from '@/services/QA/cron-settings/forms/CreateCronFilterForm';
import TicketRepositoryInterface, { CronFilterInterface } from '@/services/QC-V2/ticket/interfaces';

@Component({
  inject: [
    'ticketRepositoryV2',
  ],
})
export default class UpdateTicketCronConfig extends Vue {
  private form: WPXFormValue<CreateCronFilterForm> = new WPXFormValue(CreateCronFilterForm);
  private ticketRepositoryV2!: TicketRepositoryInterface;
  private loading: boolean = true;
  private filter!: CronFilterInterface;

  private properties: Array<{ key: string, value: string }> = [
    { key: 'Client ID', value: 'client_id' },
    { key: 'Client Name', value: 'name' },
    { key: 'Client Email', value: 'email' },
    { key: 'Ticket Status', value: 'status' },
    { key: 'Department', value: 'department' },
  ];

  private async created(): Promise<void> {
    if (!this.$route.params.id) {
      this.$errorDialog.show('Config Id Not Provided!');
      return ;
    }
    const filter = await this.ticketRepositoryV2.getFilterById(Number(this.$route.params.id));
    this.filter = filter;
    this.form.data.property = filter.property;
    this.form.data.value = filter.value;
    this.loading = false;
  }

  private async editFilter(): Promise<void> {
    try {
      await this.ticketRepositoryV2.updateCronFilter(this.filter.id, {
        property: this.form.data.property,
        value: this.form.data.value,
      });

      this.$successDialog.show('Filter Edited Successfully');
      await this.$router.push({ name: 'ticket_cron_config' });
    } catch (e) {
      this.$errorDialog.show(e.response?.data?.message);
    }
  }
}
